<template>
    <div class="box">
        <svg-icon class-name="international-icon" icon-class="rate" @click.native="click"/>
        <el-dialog title="汇率转换"
                   :visible.sync="exchangeRateDialogVisible" :modal-append-to-body='false'
                   width="40%">
            <el-form class="admin-pw-form" :model="exchangeRate"
                     ref="adminPwForm" size="small">
                <el-form-item>
                    <!--                    <p class="el-form-item">1美元=6.4693人民币</p>-->
                    <p class="show-text">{{ showText }}</p>
                </el-form-item>
                <el-row class="cm_box_g">
                    <el-col :span="19">
                        <el-form-item label="转换计算：">
                            <el-input style="width: 200px;" v-model="exchangeRate.amount" @input="handleAmountChang">
                                <template slot="append">{{ exchangeRate.originalCurrencySymbol }}</template>
                            </el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row  class="cm_box_g">
                    <el-col :span="7">
                        <el-form-item prop="weight">
                            <el-select v-model="exchangeRate.originalCurrencyId" style="width: 120px;"
                                       placeholder="请选择币种"
                                       filterable
                                       @change="handleChange">
                                <el-option
                                    v-for="item in list"
                                    :key="item.value"
                                    :label="item.currencyName+'-'+item.currencySymbol"
                                    :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="4" class="convert-box" @click.native="handleConver">
                        <svg-icon class-name="convert-icon" icon-class="convert"/>
                    </el-col>
                    <el-col :span="7">
                        <el-form-item prop="weight">
                            <el-select v-model="exchangeRate.newCurrencyId" style="width: 120px;"
                                       placeholder="请选择币种"
                                       filterable
                                       @change="handleChange">
                                <el-option
                                    v-for="item in list"
                                    :key="item.value"
                                    :label="item.currencyName+'-'+item.currencySymbol"
                                    :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="4">
                        <el-button type="primary" @click="calcConverAmount" size="small" style="margin-left: 10px;">转 换</el-button>
                    </el-col>
                </el-row>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="closeClick" size="small">取 消</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import {
    fetchList,
    realTimeExchangeRateConver
} from '@/api/exchangeRateSetting'

export default {
    name: "exchangeRateTool",
    data() {
        return {
            exchangeRateDialogVisible: false,
            exchangeRate: {
                originalCurrencyId: 3,
                newCurrencyId: 2,
                originalCurrencySymbol: null,
                amount: 100,
            },
            showText: "",
            list: [],
        }
    },
    created() {
        this.getList();
    },
    methods: {
        getList() {
            fetchList({
                pageNum: 1,
                pageSize: 10,
            }).then(response => {
                this.list = response.data.list;
            });
        },
        handleAmountChang() {
            let amount = this.exchangeRate.amount;
            this.exchangeRate.amount = amount
                .replace(/[^0-9.]/g, '')
                .replace('.', '#*')
                .replace(/\./g, '')
                .replace('#*', '.');
        },
        click() {
            this.exchangeRate.amount =100;
            this.calcConverAmount();
            this.exchangeRateDialogVisible = true;
        },
        closeClick() {
            this.exchangeRateDialogVisible = false;
        },
        calcConverAmount() {
            let originalCurrencyId = this.exchangeRate.originalCurrencyId;
            let newCurrencyId = this.exchangeRate.newCurrencyId;
            let amount = this.exchangeRate.amount;
            if (originalCurrencyId === null || originalCurrencyId === undefined || originalCurrencyId === ""
                || newCurrencyId === null || newCurrencyId === undefined || newCurrencyId === "") {
                // this.$message({
                //     message: '请选择需要转换的币种！',
                //     type: 'warning',
                //     duration: 1000
                // });
                return;
            }

            let originalExchangeRate = this.getExchangeRate(originalCurrencyId);
            let newExchangeRate = this.getExchangeRate(newCurrencyId);
            this.exchangeRate.originalCurrencySymbol = originalExchangeRate.currencySymbol;
            if (originalExchangeRate.id === newExchangeRate.id) {
                this.showText = amount.toFixed(2) + originalExchangeRate.currencyName + "=" + amount.toFixed(2) + newExchangeRate.currencyName;
            } else {
                let showAmount = 0;
                //人民币转港币
                /*if (originalExchangeRate.currencySymbol=="CNY" && newExchangeRate.currencySymbol=="HKD"){
                    let rmbToHkExchangeRate = Number.parseFloat(originalExchangeRate.rmbPrice/newExchangeRate.currencyPrices);
                    showAmount = Number.parseFloat(amount/rmbToHkExchangeRate).toFixed(4);
                }
                //人民币转美元
                if (originalExchangeRate.currencySymbol=="CNY" && newExchangeRate.currencySymbol=="USD"){
                    let rmbToUsdExchangeRate = Number.parseFloat(newExchangeRate.rmbPrice/newExchangeRate.currencyPrices);
                    showAmount = Number.parseFloat(amount/rmbToUsdExchangeRate).toFixed(4);
                }
                //港币转人民币
                if (originalExchangeRate.currencySymbol=="HKD" && newExchangeRate.currencySymbol=="CNY"){
                    let hkToRmbExchangeRate = Number.parseFloat(originalExchangeRate.rmbPrice/originalExchangeRate.currencyPrices);
                    showAmount = Number.parseFloat(amount*hkToRmbExchangeRate).toFixed(4);
                }
                //港币转美元
                if (originalExchangeRate.currencySymbol=="HKD" && newExchangeRate.currencySymbol=="USD"){
                    let hkToRmbExchangeRate = Number.parseFloat(originalExchangeRate.rmbPrice/originalExchangeRate.currencyPrices);
                    let rmbPrice = Number.parseFloat(amount*hkToRmbExchangeRate);
                    let rmbToUsdExchangeRate = Number.parseFloat(newExchangeRate.rmbPrice/newExchangeRate.currencyPrices);
                    showAmount = Number.parseFloat(rmbPrice/rmbToUsdExchangeRate).toFixed(4);
                }
                //美元转人民币
                if (originalExchangeRate.currencySymbol=="USD" && newExchangeRate.currencySymbol=="CNY"){
                    let usdToRmbExchangeRate = Number.parseFloat(originalExchangeRate.currencyPrices/originalExchangeRate.rmbPrice);
                    showAmount = Number.parseFloat(amount/usdToRmbExchangeRate).toFixed(4);
                }
                //美元转港币
                if (originalExchangeRate.currencySymbol=="USD" && newExchangeRate.currencySymbol=="HKD"){
                    let usdToRmbExchangeRate = Number.parseFloat(originalExchangeRate.currencyPrices/originalExchangeRate.rmbPrice);
                    let rmbPrice = Number.parseFloat(amount/usdToRmbExchangeRate);
                    let rmbToHkExchangeRate = Number.parseFloat(newExchangeRate.rmbPrice/newExchangeRate.currencyPrices);
                    showAmount = Number.parseFloat(rmbPrice/rmbToHkExchangeRate).toFixed(4);
                }*/
                realTimeExchangeRateConver({
                    originalExchangeRateId: originalCurrencyId,
                    newExchangeRateId: newCurrencyId,
                    price: amount,
                }).then(response => {
                    showAmount = response.data;
                    this.showText = amount.toFixed(2) + originalExchangeRate.currencyName + "=" + showAmount.toFixed(2) + newExchangeRate.currencyName;
                })

            }
        },
        handleChange() {
            this.calcConverAmount();
        },
        handleConver() {
            let originalCurrencyId = this.exchangeRate.originalCurrencyId;
            let newCurrencyId = this.exchangeRate.newCurrencyId;
            this.exchangeRate.originalCurrencyId = newCurrencyId;
            this.exchangeRate.newCurrencyId = originalCurrencyId;
        },
        getExchangeRate(id) {
            for (let i = 0; i < this.list.length; i++) {
                if (this.list[i].id == id) {
                    return this.list[i];
                }
            }
            return null;
        }
    }
}
</script>

<style scoped>
.box {
    float: left;
    /*width: 25px;*/
    /*height: 25px;*/
}

.admin-pw-form{
    margin: 0 25%;
}

.international-icon {
    margin-right: 10px;
    width: 1.7em!important;
    height: 1.7em!important;;
    vertical-align: -0.5em!important;;
    fill: currentColor;
    overflow: hidden;
    cursor: pointer;
}

.cm_box_g {
    line-height: 0;
}

.convert-box {
    width: 3em;
    height: 2.25em;
    float: left;
    text-align: center;
}

.convert-icon {
    margin: 0 10px;
    margin-top: 7px;
    width: 1.5em;
    height: 1.5em;
    vertical-align: 0em;
    fill: currentColor;
    overflow: hidden;
    cursor: pointer;
}

.show-text {
    font-size: 22px;
    margin: 0;
    margin-bottom: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/exchangeRateTool/index.vue